<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="8.25"
      :stroke="stroke"
      stroke-width="1.8"
    />
    <path
      d="M9.45 9.3C9.65 7.92 10.64 7.05 12.02 7.05C13.56 7.05 14.65 8.01 14.65 9.43C14.65 10.59 13.98 11.27 12.79 12.03C11.78 12.67 11.42 13.28 11.42 14.3"
      :stroke="stroke"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="11.42" cy="16.62" r="0.95" :fill="stroke" />
  </svg>
</template>

<script>
export default {
  name: "HelpCenterIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },

    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
